import { PiList } from '../server-types';

interface IGraphQLMedia {
	id: string;
	origUrl?: string;
	smallThumbUrl?: string;
	mediumThumbUrl?: string;
	largeThumbUrl?: string;
}

/**
 * Utility per mimare l'aspetto di un Media GraphQL dato un formato proveniente da Wordpress
 *
 * @param mediaSizes: string
 * @return IGraphQLMedia
 */
const oldMediaToGraphqlMedia = (
	mediaSizes: string | undefined | null,
): IGraphQLMedia | null => {
	if (mediaSizes === null || mediaSizes === undefined) {
		return null;
	}
	const tmp = JSON.parse(mediaSizes);
	return {
		id: tmp.full.file,
		origUrl: tmp.full.source_url,
		smallThumbUrl: tmp.thumbnail.source_url,
		mediumThumbUrl: tmp.medium.source_url,
		largeThumbUrl: tmp.large && tmp.large.source_url,
	};
};

/**
 * Utility per passare da un risultato paginato (tipo edges.renderNode) ad un array di entita'
 *
 * @param queryResult: { edges: ReadonlyArray<{ renderNode: any }> }
 * @return any[]
 */
function nodes<T = any>(queryResult: { edges: ReadonlyArray<{ node: T }> }): T[] {
	return queryResult.edges.map((o) => o.node);
}

/**
 * Utility per sistemare i dati delle PiList che, provenendo da Pardot, sono malformati o scomodi
 *
 * @param piList: PiList
 * @return PiList & { sfBrandId: string | undefined }
 */
const fixPiList = (piList: PiList): PiList & { sfBrandId: string | undefined } =>
	Object.assign({}, piList, {
		sfBrandId: piList.name ? piList.name.split(' - ')[0] : undefined,
	});

export { oldMediaToGraphqlMedia, nodes, fixPiList };
